










































import {Component, Prop, Vue} from 'vue-property-decorator';
import {Location} from "vue-router"
import { Portal } from '@linusborg/vue-simple-portal'

/**
 * @status stable
 * @published 4.5.0
 * @changelog 4.5.0 Published.
 * @changelog 4.5.1 Use `vue-simple-portal` to ensure avoid issues with router views embedded in sheets.
 * @changelog 4.5.3 Add close button.
 * @changelog 4.5.5 Add vertical bleed and proper support for left bar.
 * @changelog 4.7.1 Make scrollbars `auto` instead of `scroll`.
 * @changelog 4.7.2 Prevent scrollbar flash on long sheets.
 * @changelog 4.8.2 Lock the page in the background while a sheet is up.
 *
 * @todo find a more robust way to make sure clicking _anywhere_ on the backdrop closes the sheet.
 * @todo properly focus-trap within a sheet when it's up.
 */
@Component({
    components: {SimplePortal: Portal}
})
export default class JdsSheet extends Vue {
    /**
     * Where to go upon clicking the close button or clicking on the edge backdrop. In general,
     * this should go to whatever is intuitively "behind" the sheet.
     *
     * **By default, this just performs a browser "back" action**. This is not acceptable if the
     * sheet contains routing within itself, and those sheets **must** have an explicit `to` Location.
     */
    @Prop() to!: Location

    get hasLeftSidebar() {
        return this.$slots['left']
    }

    mounted() {
        document.body.style.overflow = 'hidden'
    }

    beforeDestroy() {
        document.body.style.overflow = 'visible'
    }

    handleClose () {
        if (this.to) {
            this.$router.push(this.to)
        } else {
            this.$router.back()
        }
    }

}
